export function empreendimentoInfoWindow(empreendimento, marker, currentInfoWindow) {
    if (currentInfoWindow) {
        currentInfoWindow.close();
        currentInfoWindow = null;
    }

    const cep = empreendimento.cep.slice(0, 5) + "-" + empreendimento.cep.slice(5);

    const htmlContent = `
        <div class="custom-infowindow">
            <h3>${empreendimento.nome}</h3>
            <p><strong>Endereço:</strong> 
            ${empreendimento.endereco},
             ${empreendimento.numero} - 
             ${empreendimento.bairro}, 
             ${empreendimento.cidade} - 
             ${empreendimento.estado},
             ${cep}
             </p>
        </div>
    `;

    const position = {
        lat: empreendimento.location.coordinates[1],
        lng: empreendimento.location.coordinates[0]
    };

    const newInfoWindow = new google.maps.InfoWindow({
        content: htmlContent,
        position: position,
    });

    newInfoWindow.open({
        anchor: marker,
        map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    });

    return newInfoWindow;
}

export function poloInfoWindow(polo, marker, currentInfoWindow) {
    if (currentInfoWindow) {
        currentInfoWindow.close();
        currentInfoWindow = null;
    }

    let htmlContent = `
        <div>
            <h5>${polo.title}</h5>
            <small>
                <strong>Endereço: </strong>${polo.formatted_address} <br />
            </small>
        </div>
                        `;

    let position = { lat: polo.position.coordinates[1], lng: polo.position.coordinates[0] };

    const newInfoWindow = new google.maps.InfoWindow({
        content: htmlContent,
        position: position,
    });

    newInfoWindow.open({
        anchor: marker,
        map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    });

    return newInfoWindow;

}

export function poloInfoWindowShopping(polo, marker, currentInfoWindow) {
    if (currentInfoWindow) {
        currentInfoWindow.close();
        currentInfoWindow = null;
    }

    function area(value) {
        value = Number(value);

        if (!value) {
            return '-';
        }

        return `${value.toLocaleString('pt-BR')} m²`;
    }

    function floor(value) {
        value = Number(value);

        if (!value) {
            return '-';
        }

        return `${value.toLocaleString('pt-BR')} ${
            value === 1 ? 'piso' : 'pisos'
        }`;
    }

    function room(value) {
        value = Number(value);

        if (!value) {
            return '-';
        }

        return `${value.toLocaleString('pt-BR')} ${
            value === 1 ? 'sala' : 'salas'
        }`;
    }

    function parking(value) {
        value = Number(value);

        if (!value) {
            return '-';
        }

        return `${value.toLocaleString('pt-BR')} ${
            value === 1 ? 'vaga' : 'vagas'
        }`;
    }

    function percentage(value) {
        value = Number(value);

        return `${value || 0}%`;
    }

    let htmlContent = `
        <div>
            <h5>${polo.title}</h5>
            <small>
                <strong>Endereço: </strong>${polo.formatted_address} <br />
                <strong>ABL (m2): </strong>${area(polo?.abl)} <br />
                <strong>Area Construída (m²): </strong>${area(polo?.area_construida)} <br />
                <strong>Área do Terreno (m²): </strong>${area(polo?.area_terreno)} <br />
                <strong>Administração: </strong>${polo?.administracao ?? '-'} <br />
                <strong>Pisos do Shopping: </strong>${floor(polo?.pisos_shopping)} <br />
                <strong>Total de Lojas: </strong>${Number(polo?.total_lojas ?? 0)} <br />
                <strong>Lojas Âncora: </strong>${Number(polo?.lojas_ancora ?? 0)} <br />
                <strong>Megalojas: </strong>${Number(polo?.mega_lojas ?? 0)} <br />
                <strong>Quisques: </strong>${Number(polo?.quiosques ?? 0)} <br />
                <strong>Conveniência e Serviços: </strong>${Number(polo?.conveniencia_servicos ?? 0)} <br />
                <strong>Alimentação: </strong>${Number(polo?.alimentacao ?? 0)} <br />
                <strong>Entretenimento: </strong>${polo?.entretenimento ?? '-'} <br />
                <strong>Cinema: </strong>${room(polo?.cinema)} <br />
                <strong>Estacionamento: </strong>${parking(polo?.estacionamento)} <br />
                <strong>Perfil A: </strong>${percentage(polo?.perfil_a)} <br />
                <strong>Perfil B: </strong>${percentage(polo?.perfil_b)} <br />
                <strong>Perfil C: </strong>${percentage(polo?.perfil_c)} <br />
                <strong>Perfil D: </strong>${percentage(polo?.perfil_d)} <br />
                <strong>Média mensal de visitantes: </strong>${Number(polo?.media_mensal_visitantes ?? 0)} <br />
            </small>
        </div>
                        `;

    let position = { lat: polo.position.coordinates[1], lng: polo.position.coordinates[0] };

    const newInfoWindow = new google.maps.InfoWindow({
        content: htmlContent,
        position: position,
    });

    newInfoWindow.open({
        anchor: marker,
        map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    });

    return newInfoWindow;

}